export default {
    other: 'Other',
    home: 'HOME',
    product: 'PRODUCT',
    server: 'SERVICE',
    case: 'SUCCESS STORY',
    jobs: 'HIRING',
    about: 'ABOUT US',
    productTitle: 'NEW PRODUCTS',
    more: 'MORE',
    newsTitle: 'NEWS',
    caseTitle: 'PROFESSIONL ENGINEERING CAPABLITY',
    introduction: 'ABOUT TORVANDOM',
    contact: 'CONTACT US',
    intDes: 'Head Quarter based in Canada,  TORVANDOM is such a professional company with the long term practise and expertise in Industry,  Power, Infrastructure Construction sectors. We develop a series of high quality Sealing & Electric protection solutions and help our customers to achieve the long term reliable protection for their critical Equipment and Facility as well as their Asset. ',
    company: 'TORVANDOM (SUZHOU) INDUSTRY CO., LTD. ',
    address: 'Dushu Lake Building 4C-2,  Tongda Road No.1301, Guoxiang, Wuzhong District, Suzhou, China',
    phone: 'Phone：0512-66872807'
}



// WEBPACK FOOTER //
// ./src/locales/en.js